<template>
  <!-- Main Content -->
    <div id="search-item-gallery" class="md-layout md-gutter w-100 justify-content-center" ref="groupPage">
      <!-- the div below is only an exemple waiting for the proper design in case there are no items on the group-->
      <div v-if=" !allItems.length">
        No available items from this user
      </div>
      <div class="category-items-layout">
        <div class="item-galery-layout">
          <div
            v-for="(item, index) in allItems"
            class="md-layout-item" 
            :key="index"
          >
            <SNewItemMaterial
              :item="item"
              v-if="item.feedType === 'NEW_ITEM'"
              @openWindowPopup="openChat(item)"
              @deleteItem="reloadData(item)"
            />
          </div>
        </div>
      </div>

    </div>

  <!-- ... end Main Content -->

  <!-- Left Sidebar -->
</template>

<script>
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import SNewItemMaterial from "@/material-components/organisms/SNewItemMaterial.vue";
import ItemHelper from '../../mixins/ItemHelper.vue';

export default {
  name: "GroupsItems",
  props: ["items"],
  mixins: [GroupHelperVue, ChatHelperVue, ItemHelper],
  components: {
    SNewItemMaterial,
  },
  data() {
    return {
      selectedKeyChat: {},
    };
  },
  computed: {
    allItems() {
      let result = [];
      if (this.items) {
        result = [...this.items];
      } else {
        const items = this.getCurrentGroupItems || [];
        result = [...items];
      }

      return result.filter((item) => this.getItemAvailability(item));
    },
  },
  methods: {
    openChat(key) {
      const selectedKeyId = key.id ?? key.group.id;
      const msgs = this.userMessages.some((msg) => {
        return msg.key.id === selectedKeyId;
      });
      if (!msgs) {
        this.selectedKeyChat = {
          key: key,
          messages: [],
          firstTalk: true,
        };
      } else {
        this.selectedKeyChat = this.userMessages.find((msg) => {
          return msg.key.id === selectedKeyId;
        });
      }
      this.selectedKeyChat = {
        ...this.selectedKeyChat,
        partner: key.user,
      };
      this.setPopupChat({
        isOpen: true,
        chatMsgs: this.selectedKeyChat,
      });
      this.$parent.$parent.$refs.rightStickyBar.openClosePopup();
    },
    reloadData(index) {
      this.allActivities.splice(index, 1);
      this.feedKey += 1;
    },
  },
};
</script>
<style scoped>
.md-layout-item {
  margin: 0 8px 16px !important;
  padding: 0 !important;
  max-width: 575px;
}
.md-layout.md-gutter {
  margin: 0;
}
.item-galery-layout {
  display: flex;
  flex-wrap: wrap;
}
.category-items-layout {
  display: flex;
  flex-direction: column;
}
</style>
